// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationLoader_root__fRtjm","useFade-fadeIn":"NavigationLoader_useFade-fadeIn__4Br_F","useFade-fadeOut":"NavigationLoader_useFade-fadeOut__t_RgC"};